var _g, _g2, _g3, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMainBackgroundTablet = function SvgMainBackgroundTablet(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 768 627",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-tablet_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M123.398 36.32h269.324V274.31c0 18.542-15.031 33.572-33.573 33.572H123.398V36.321Z",
    fill: "#fff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-tablet_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M606 319.496h187.258V163.572c0-18.541-15.031-33.572-33.572-33.572H606v189.496Z",
    fill: "#fff"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#main-background-tablet_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-115.337 307.881h238.735v198.788c0 23.638-19.162 42.801-42.8 42.801h-195.935V307.881Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "main-background-tablet_svg__a",
    x: 87.337,
    y: 0.259,
    width: 365.487,
    height: 367.725,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.021,
    dy: 12.021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.041
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "main-background-tablet_svg__b",
    x: 569.939,
    y: 93.939,
    width: 283.422,
    height: 285.66,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12.021,
    dy: 12.021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 24.041
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "main-background-tablet_svg__c",
    x: -161.312,
    y: 261.907,
    width: 361.335,
    height: 364.188,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 15.325,
    dy: 15.325
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 30.65
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_440_265"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in: "SourceGraphic",
    in2: "effect1_dropShadow_440_265",
    result: "shape"
  })))));
};

export { SvgMainBackgroundTablet as ReactComponent };
export default __webpack_public_path__ + "f67411fee8725b6fb929862699bc33e8.svg";